var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"context-list",class:{ 'context-list--visible': _vm.visible }},[_vm._t("default"),_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"context-list__item",on:{"click":function($event){return _vm.select(item)}}},[_vm._v(" "+_vm._s(_vm.layout(item))+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }